import { render, staticRenderFns } from "./InspectionFilter.vue?vue&type=template&id=673857f4&"
import script from "./InspectionFilter.vue?vue&type=script&lang=js&"
export * from "./InspectionFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports